import Helpers from "./helpers";
import Logger from "./logger";
import site from "../site";

declare var dataLayer: any;

export default class GlobalHeader {

	private basketSummaryEndpoint = "/api/basketsummary";
	private authenticatedEndpoint = "/api/authenticated";
	private customerEmailEndpoint = "/api/customeremail";

	constructor() {
		if (window.fetch) {
			this.getBasketSummary();
			this.getAuthenticatedState();
			this.getCustomerEmail();
		}
	}

	private getBasketSummary() {
		const navBasketCountElement = document.querySelector('#navBasketCount');
		fetch(this.basketSummaryEndpoint)
			.then(response => response.json())
			.then((response: {
				TotalItemQuantity: number;
			}) => {
				navBasketCountElement.textContent = response.TotalItemQuantity.toString();
			})
			.catch((error) => {
				Logger.trackException(error, 'Unexpected error getting header basket summary');
				Helpers.removeElement(navBasketCountElement);
			});
	}

	private getAuthenticatedState () {
		fetch(this.authenticatedEndpoint)
			.then(response => response.json())
			.then((response: {
				IsAuthenticated: boolean;
			}) => {
				if (response.IsAuthenticated) {
					this.setupAuthenticatedAccountNavigation();
				}
			})
			.catch((error) => {
				Logger.trackException(error, 'Unexpected error getting header account information');
			});
	}

	private getCustomerEmail() {
		fetch(this.customerEmailEndpoint)
			.then(response => response.json())
			.then((response: {
				UserEmailMD5: string;
				UserEmailSHA256: string;
			}) => {
				if (response.UserEmailMD5 && response.UserEmailSHA256) {
					dataLayer.push({
						'user_email_md5': response.UserEmailMD5,
						'user_email_sha256': response.UserEmailSHA256
					});
				}
			})
			.catch((error) => {
				Logger.trackException(error, 'Unexpected error getting header customer email');
			});
	}

	private setupAuthenticatedAccountNavigation() {
		const headerAccountElement = document.querySelector('.js-header-account-item');
		headerAccountElement.classList.add('c-header__utils__item--with-sub');
		headerAccountElement.classList.add('js-header-utils-item');
		document.querySelector('.js-header-account-nav').setAttribute('aria-hidden', 'false');
		site.userNav();
	}

}
